import { lazy } from 'react';

export const AdminCalendarPage = lazy(() => import('./AdminCalendarPage'));
